<template>
  <b-form-checkbox-group
    v-model="local_value"
    :options="options"
    :name="name_checkboxes"
    stacked
  ></b-form-checkbox-group>
</template>

<script>
import {
  formControlMixin,
  props as formControlProps,
} from "bootstrap-vue/src/mixins/form-control";

import {
  formStateMixin,
  props as formStateProps,
} from "bootstrap-vue/src/mixins/form-state";

import { sortKeys } from "bootstrap-vue/src/utils/object";
import { makePropsConfigurable } from "bootstrap-vue/src/utils/props";
import { mapActions } from "vuex";
import _ from "lodash";
const props = makePropsConfigurable(
  sortKeys({
    ...formStateProps,
    ...formControlProps,
    value: null,
  })
);

export default {
  mixins: [formControlMixin, formStateMixin],
  props,
  data: () => ({
    local_id: "",
    options: [],
  }),
  computed: {
    name_checkboxes() {
      return "checkboxes-" + this.local_id;
    },
    local_value: {
      set(value) {
        let emit_value = [];
        value.forEach((id) => {
          emit_value.push({ id: id });
        });
        this.$emit("input", emit_value);
      },
      get() {
        let response = [];
        if (Array.isArray(this.value)) {
          response = _.map(this.value, "id");
        }
        return response;
      },
    },
  },
  methods: {
    ...mapActions("categorias", ["ActionToSelect"]),
  },
  mounted() {
    this.local_id = this._uid;
  },
  async created() {
    this.options = await this.ActionToSelect();
  },
};
</script>
